(function () {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiVirKeyboard', taiVirKeyboard);

    function taiVirKeyboard() {
        var directive = {
            require: ['^form', '^ngController'],
            bindToController: true,
            controller: ControllerController,
            templateUrl: 'directive/taiVirKeyboard.html',
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                onDataChanged: '='
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(modalService, $scope) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.data = $scope.$parent.vm.virData;
        vm.caps = false;
        vm.kbType = 1; // 1-letter ; 2-symbol
        vm.focusObj = null;
        vm.keyMap = {};
        vm.isInitKeyboard = false;
        vm.showKeyboard = showKeyboard;
        vm.new_keybord = new_keybord;
        vm.initKeyElement = initKeyElement;
        vm.getLetterKeyboard = getLetterKeyboard;
        vm.getSymKeyboard = getSymKeyboard;

        // Virtual Keyboard Init
        vm.num_array = new Array();
        vm.sym_arr = new Array();
        vm.en_b_array = new Array();
        vm.showKeyboard();
        //------------------------

        function getMapKey(key) {
            if (typeof vm.keyMap[key] === "undefined") return key;
            return vm.keyMap[key];
        }

        // 顯示小鍵盤
        function showKeyboard() {
            if (!vm.isInitKeyboard) {
                //執行產生新鍵盤
                vm.initKeyElement();
                vm.new_keybord();

                vm.isInitKeyboard = true
            }

            //開啟html元素
            $("#keyboard").show();
            $("#flashcontent").show();
        }


        // //清除輸入欄
        // $(".Keyboard_reset").click(function() {
        //     vm.focusObj.val("");
        //     vm.focusObj.trigger('change')
        // })

        //從一個給定的arr陣列中，隨機返回num個不重複項
        function getArrayItems(arr, num) {
            //新鍵一個陣列，將傳入的陣列複製過來，用於運算，不直接操作傳入的陣列
            var temp_array = new Array();
            for (var index in arr) {
                temp_array.push(arr[index]);
            }
            //取出的項目，保存在此陣列
            var return_array = new Array();
            for (var i = 0; i < num; i++) {
                //判斷如果陣列還有可以取出的元素，以防下標越界
                if (temp_array.length > 0) {
                    //在陣列中產生一個隨機索引
                    //2023-09-20 Johnson 資安2023
                    var arrIndex = Math.floor(eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('0.1()',2,2,'Math|random'.split('|'),0,{})) * temp_array.length);
                    return_array[i] = temp_array[arrIndex];
                    //刪掉此索引的陣列元素，此時temp_array變為新的陣列
                    temp_array.splice(arrIndex, 1);
                } else {
                    //陣列項目取完後，退出迴圈，比如陣列本來只有10項，但要求取出20項
                    break;
                }
            }
            return return_array;
        }

        function new_keybord() {

            if (vm.kbType === 1) {
                vm.getLetterKeyboard();

                $(".kb_num").each(function () {
                    var kbNum = $(this).attr("title");
                    $(this).addClass("n_" + kbNum);
                });

                $(".kb_en").each(function () {
                    var kbNum = $(this).attr("title");
                    $(this).addClass("l_" + kbNum);
                });
            } else {
                vm.getSymKeyboard();

                //將背景圖的class加入含有.kb class的td中
                $(".kb_sy").each(function () {
                    var kbNum = $(this).attr("title");
                    $(this).addClass("l_" + kbNum);
                });
            }
            //dom建立完畢

            //按下小鍵盤 (取值寫入inputText)
            $(".kb_num, .kb_en , .kb_sy").click(function () {
                //取值
                vm.data = vm.data || '';
                var key = $(this).attr("title");
                vm.data += getMapKey(key);
                vm.onDataChanged(vm.data);

                //console.log('data:', vm.data);
            });

            //更改樣式
            // $(".kb_num, .kb_en , .kb_sy").hover(
            //     function () {
            //         var $this = $(this);
            //         $this.addClass("Keyboard_hover");
            //     },
            //     function () {
            //         var $this = $(this);
            //         $this.removeClass("Keyboard_hover");
            //     }
            // );

            //按下切換
            $(".Keyboard_s").click(function () {
                $("#keyboard tr:lt(5)").html("");
                if (vm.kbType == 1) {
                    vm.kbType = 2;
                } else {
                    vm.kbType = 1;
                }
                vm.new_keybord();
            });

            //按下更新
            $(".Keyboard_r").click(function () {
                $("#keyboard tr:lt(5)").html("");
                vm.new_keybord();
                if (vm.caps) {
                    $(".Keyboard_caps").toggleClass("capsDown");
                    $("#keyboard a[class^='kb_en']").each(function () {
                        //切換大寫title
                        var titleName = $(this).attr("title");
                        titleName = titleName.toUpperCase();
                        $(this).attr("title", titleName);
                    });
                }
            });

            //按下大寫切換
            $(".Keyboard_caps").click(function () {
                //判斷是否按下[大寫]
                if ($(".Keyboard_caps").hasClass("capsDown")) {
                    $(this).toggleClass("capsDown");
                    vm.caps = false;
                    $("#keyboard a[class^='kb_en']").each(function () {
                        //切換小寫title
                        var titleName = $(this).attr("title");
                        titleName = titleName.toLowerCase();
                        $(this).attr("title", titleName);

                    });
                } else {
                    vm.caps = true;
                    $(this).toggleClass("capsDown");
                    $("#keyboard a[class^='kb_en']").each(function () {
                        //切換大寫title
                        var titleName = $(this).attr("title");
                        titleName = titleName.toUpperCase();
                        $(this).attr("title", titleName);
                    });
                }

                $(".Keyboard_caps").each(function () {
                    //切換大小寫title
                    var titleName = $(this).attr("title");
                    if (!vm.caps) {
                        titleName = '⇧';
                    } else {
                        titleName = '⇡';
                    }
                    $(this).attr("title", titleName);
                });
            })

            //清除輸入欄
            $(".Keyboard_reset").click(function () {
                vm.data = '';
                vm.onDataChanged(vm.data);
            })
        }

        /**
         * 定義鍵盤所需元素
         */
        function initKeyElement() {
            //產生0~9的html存入陣列
            for (var i = 0; i < 10; i++) {
                vm.num_array[i] = "<td class='tp-num'><a class='kb_num' style='cursor:pointer;' title='" + i + "'></a></td>"
            }

            //產生特殊字元陣列
            vm.sym_arr[0] = "<td><a class='kb_sy' style='cursor:pointer;' title='!'></a></td>";
            vm.sym_arr[1] = "<td><a class='kb_sy' style='cursor:pointer;' title='@'></a></td>";
            vm.sym_arr[2] = "<td><a class='kb_sy' style='cursor:pointer;' title='#'></a></td>";
            vm.sym_arr[3] = "<td><a class='kb_sy' style='cursor:pointer;' title='$'></a></td>";
            vm.sym_arr[4] = "<td><a class='kb_sy' style='cursor:pointer;' title='%'></a></td>";
            vm.sym_arr[5] = "<td><a class='kb_sy' style='cursor:pointer;' title='^'></a></td>";
            vm.sym_arr[6] = "<td><a class='kb_sy' style='cursor:pointer;' title='&'></a></td>";
            vm.sym_arr[7] = "<td><a class='kb_sy' style='cursor:pointer;' title='*'></a></td>";
            vm.sym_arr[8] = "<td><a class='kb_sy' style='cursor:pointer;' title='('></a></td>";
            vm.sym_arr[9] = "<td><a class='kb_sy' style='cursor:pointer;' title=')'></a></td>";
            vm.sym_arr[10] = "<td><a class='kb_sy' style='cursor:pointer;' title='`'></a></td>";
            vm.sym_arr[11] = "<td><a class='kb_sy' style='cursor:pointer;' title='~'></a></td>";
            vm.sym_arr[12] = "<td><a class='kb_sy' style='cursor:pointer;' title='-'></a></td>";
            vm.sym_arr[13] = "<td><a class='kb_sy' style='cursor:pointer;' title='_'></a></td>";
            vm.sym_arr[14] = "<td><a class='kb_sy' style='cursor:pointer;' title='+'></a></td>";
            vm.sym_arr[15] = "<td><a class='kb_sy' style='cursor:pointer;' title='='></a></td>";
            vm.sym_arr[16] = "<td><a class='kb_sy' style='cursor:pointer;' title='['></a></td>";
            vm.sym_arr[17] = "<td><a class='kb_sy' style='cursor:pointer;' title='{'></a></td>";
            vm.sym_arr[18] = "<td><a class='kb_sy' style='cursor:pointer;' title=']'></a></td>";
            vm.sym_arr[19] = "<td><a class='kb_sy' style='cursor:pointer;' title='}'></a></td>";
            vm.sym_arr[20] = "<td><a class='kb_sy' style='cursor:pointer;' title='|'></a></td>";
            vm.sym_arr[21] = "<td><a class='kb_sy' style='cursor:pointer;' title=':'></a></td>";
            vm.sym_arr[22] = "<td><a class='kb_sy' style='cursor:pointer;' title=';'></a></td>";
            vm.sym_arr[23] = "<td><a class='kb_sy' style='cursor:pointer;' title=','></a></td>";
            vm.sym_arr[24] = "<td><a class='kb_sy' style='cursor:pointer;' title='.'></a></td>";
            vm.sym_arr[25] = "<td><a class='kb_sy' style='cursor:pointer;' title='<'></a></td>";
            vm.sym_arr[26] = "<td><a class='kb_sy' style='cursor:pointer;' title='>'></a></td>";
            vm.sym_arr[27] = "<td><a class='kb_sy' style='cursor:pointer;' title='?'></a></td>";
            // vm.sym_arr[28] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[29] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[30] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[31] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[32] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[33] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[34] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[35] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";


            //產生a~z的html存入陣列
            vm.en_b_array[0] = "<td><a class='kb_en' style='cursor:pointer;' title='a'></a></td>";
            vm.en_b_array[1] = "<td><a class='kb_en' style='cursor:pointer;' title='b'></a></td>";
            vm.en_b_array[2] = "<td><a class='kb_en' style='cursor:pointer;' title='c'></a></td>";
            vm.en_b_array[3] = "<td><a class='kb_en' style='cursor:pointer;' title='d'></a></td>";
            vm.en_b_array[4] = "<td><a class='kb_en' style='cursor:pointer;' title='e'></a></td>";
            vm.en_b_array[5] = "<td><a class='kb_en' style='cursor:pointer;' title='f'></a></td>";
            vm.en_b_array[6] = "<td><a class='kb_en' style='cursor:pointer;' title='g'></a></td>";
            vm.en_b_array[7] = "<td><a class='kb_en' style='cursor:pointer;' title='h'></a></td>";
            vm.en_b_array[8] = "<td><a class='kb_en' style='cursor:pointer;' title='i'></a></td>";
            vm.en_b_array[9] = "<td><a class='kb_en' style='cursor:pointer;' title='j'></a></td>";
            vm.en_b_array[10] = "<td><a class='kb_en' style='cursor:pointer;' title='k'></a></td>";
            vm.en_b_array[11] = "<td><a class='kb_en' style='cursor:pointer;' title='l'></a></td>";
            vm.en_b_array[12] = "<td><a class='kb_en' style='cursor:pointer;' title='m'></a></td>";
            vm.en_b_array[13] = "<td><a class='kb_en' style='cursor:pointer;' title='n'></a></td>";
            vm.en_b_array[14] = "<td><a class='kb_en' style='cursor:pointer;' title='o'></a></td>";
            vm.en_b_array[15] = "<td><a class='kb_en' style='cursor:pointer;' title='p'></a></td>";
            vm.en_b_array[16] = "<td><a class='kb_en' style='cursor:pointer;' title='q'></a></td>";
            vm.en_b_array[17] = "<td><a class='kb_en' style='cursor:pointer;' title='r'></a></td>";
            vm.en_b_array[18] = "<td><a class='kb_en' style='cursor:pointer;' title='s'></a></td>";
            vm.en_b_array[19] = "<td><a class='kb_en' style='cursor:pointer;' title='t'></a></td>";
            vm.en_b_array[20] = "<td><a class='kb_en' style='cursor:pointer;' title='u'></a></td>";
            vm.en_b_array[21] = "<td><a class='kb_en' style='cursor:pointer;' title='v'></a></td>";
            vm.en_b_array[22] = "<td><a class='kb_en' style='cursor:pointer;' title='w'></a></td>";
            vm.en_b_array[23] = "<td><a class='kb_en' style='cursor:pointer;' title='x'></a></td>";
            vm.en_b_array[24] = "<td><a class='kb_en' style='cursor:pointer;' title='y'></a></td>";
            vm.en_b_array[25] = "<td><a class='kb_en' style='cursor:pointer;' title='z'></a></td>";

        }

        function getLetterKeyboard() {
            //取出已亂數的數字陣列，並插入至keyboard下第1個tr    	
            vm.num_array = getArrayItems(vm.num_array, 10);
            for (let i = 0; i < vm.num_array.length; i++) {
                $("#keyboard tr:eq(0)").append(vm.num_array[i]);
            }

            //取出已亂數的小寫陣列，並插入至keyboard下第2~4個tr
            vm.en_b_array = getArrayItems(vm.en_b_array, 26);
            for (let i = 0; i < 26; i++) {
                if (i < 10) {
                    $("#keyboard tr:eq(1)").append(vm.en_b_array[i]);
                } else if (i >= 10 && i < 20) {
                    $("#keyboard tr:eq(2)").append(vm.en_b_array[i]);
                } else if (i == 20) {
                    $("#keyboard tr:eq(3)").append("<td colspan='2'><a class='Keyboard_caps' title='⇧' style='cursor:pointer;'></a></td>");
                    $("#keyboard tr:eq(3)").append(vm.en_b_array[i]);
                } else if (i == 25) {
                    $("#keyboard tr:eq(3)").append(vm.en_b_array[i]);
                    $("#keyboard tr:eq(3)").append("<td colspan='2'><a class='Keyboard_s' title='!@#' style='cursor:pointer;'></a></td>");
                } else {
                    $("#keyboard tr:eq(3)").append(vm.en_b_array[i]);
                }
            }
            //$("#keyboard tr:eq(4)").append("<td colspan='5'><a class='Keyboard_r' title='REFRESH' style='cursor:pointer;'></a></td>");
            $("#keyboard tr:eq(4)").append("<td colspan='10'><a class='Keyboard_reset' title='DELETE' style='cursor:pointer;'></a></td>");
        }

        function getSymKeyboard() {
            //取出已亂數的數字陣列，並插入至keyboard下第1個tr    	
            vm.num_array = getArrayItems(vm.num_array, 10);
            for (let i = 0; i < vm.num_array.length; i++) {
                $("#keyboard tr:eq(0)").append(vm.num_array[i]);
            }
            
            //取出已亂數的符號陣列，並插入至keyboard下第2~4個tr
            vm.sym_arr = getArrayItems(vm.sym_arr, 26);
            for (let i = 0; i < 26; i++) {
                if (i < 10) {
                    $("#keyboard tr:eq(1)").append(vm.sym_arr[i]);
                } else if (i >= 10 && i < 20) {
                    $("#keyboard tr:eq(2)").append(vm.sym_arr[i]);
                } else if (i == 20) {
                    $("#keyboard tr:eq(3)").append("<td colspan='2'><a class='Keyboard_caps' title='⇧' style='cursor:pointer;'></a></td>");
                    $("#keyboard tr:eq(3)").append(vm.sym_arr[i]);
                } else if (i == 25) {    
                    $("#keyboard tr:eq(3)").append(vm.sym_arr[i]);
                    $("#keyboard tr:eq(3)").append("<td colspan='2'><a class='Keyboard_s' title='ABC' style='cursor:pointer;'></a></td>");
                } else {
                    $("#keyboard tr:eq(3)").append(vm.sym_arr[i]);
                }

            }

            //$("#keyboard tr:eq(4)").append("<td colspan='5'><a class='Keyboard_r' title='REFRESH' style='cursor:pointer;'></a></td>");
            $("#keyboard tr:eq(4)").append("<td colspan='10'><a class='Keyboard_reset' title='DELETE' style='cursor:pointer;'></a></td>");
                
        }
    }
})();